import { ProColumns } from "@ant-design/pro-table";
import { fileHttpUrl } from "@api/baseUrl";
import { DateRangeWithDisabled } from "@components/Common";
import { Input, Select } from "antd";
import React, { ReactNode } from "react";

const options = [{label: 'options1', value: 1}, {label: 'options2', value: 2}]


const valueEnum = {
    0: { text: '全部', status: 'Default' },
    1: { text: '一致', status: 'Sueecss' },
    2: { text: '不一致', status: 'Error' },
    3: { text: '其他错误', status: 'Processing' },
}


const valueEnumCharge = {
    0: { text: '不收费', status: 'Default' },
    1: { text: '收费', status: 'Sueecss' },
}

/**
 * 列表表格配置:
 *  自定义表格 CustomerDemo 和 antd 升级版组件 ProTableDemo 都可使用, 
 * */
export const columnsFn: (operate: Function) => ProColumns<any>[] = (operate) => {
    return [
        {
            title: '调用时间',
            dataIndex: 'feeReturnDate',
            // valueType: 'dateTimeRange',
            valueType: 'dateRange',
            fieldProps: { },
            search: {
                transform: (value) => {
                    return {
                        startTime: value[0] ? value[0] + ' 00:00:00' : undefined,
                        endTime: value[1] ? value[1] + ' 23:59:59' : undefined
                    }
                },
            },
            renderFormItem: (props) => <DateRangeWithDisabled />,
            render: (text: any, record: any) => record.feeReturnDate,
        },
        {
            title: '号码总量',
            dataIndex: 'totalAmount',
            hideInSearch: true
        },
        {
            title: '计费数',
            dataIndex: 'chargeAmount',
            hideInSearch: true
        },
        {
            title: '不计费数',
            dataIndex: 'notChargeAmount',
            hideInSearch: true
        },
        {
            title: '平均计费单价（元/次）',
            dataIndex: 'chargePrice',
            hideInSearch: true
        },
        {
            title: '计费金额（元）',
            dataIndex: 'chargeMoney',
            hideInSearch: true
        },
    ]
}
